import moneyFlow from './moneyFlow'
import adwin from './adwin'
// import stoch from './stoch'

export const HEATMAP_LIST = [
  moneyFlow,
  adwin,
  // stoch,
]

export const HEATMAPS = HEATMAP_LIST.reduce((acc, cfg) => {
  acc[cfg.key] = cfg

  return acc
}, {})
